/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_Group_HelpInputs */

const en_source_group_help = /** @type {(inputs: Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the group to copy timecodes from`)
};

const fr_source_group_help = /** @type {(inputs: Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez le groupe dont copier les timecodes`)
};

const de_source_group_help = /** @type {(inputs: Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Gruppe aus, aus der die Timecodes kopiert werden sollen.`)
};

const it_source_group_help = /** @type {(inputs: Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il gruppo da cui copiare i timecode`)
};

const ru_source_group_help = /** @type {(inputs: Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите группу, из которой нужно скопировать временные коды.`)
};

const es_source_group_help = /** @type {(inputs: Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el grupo desde el cual copiar códigos de tiempo`)
};

const zh_cn2_source_group_help = /** @type {(inputs: Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要从中复制时间码的组`)
};

const ja_source_group_help = /** @type {(inputs: Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードをコピーするグループを選択します`)
};

const hi_source_group_help = /** @type {(inputs: Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड कॉपी करने के लिए समूह का चयन करें`)
};

const pt_pt2_source_group_help = /** @type {(inputs: Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o grupo do qual deseja copiar os códigos de tempo.`)
};

/**
* | output |
* | --- |
* | "Select the group to copy timecodes from" |
*
* @param {Source_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const source_group_help = /** @type {((inputs?: Source_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_source_group_help(inputs)
	if (locale === "de") return de_source_group_help(inputs)
	if (locale === "it") return it_source_group_help(inputs)
	if (locale === "ru") return ru_source_group_help(inputs)
	if (locale === "es") return es_source_group_help(inputs)
	if (locale === "zh-CN") return zh_cn2_source_group_help(inputs)
	if (locale === "ja") return ja_source_group_help(inputs)
	if (locale === "hi") return hi_source_group_help(inputs)
	if (locale === "pt-PT") return pt_pt2_source_group_help(inputs)
	return en_source_group_help(inputs)
});